import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { CountryCode } from '~/enums';
import Card from '~/components/shared/Card/Card';
import CardSection from '~/components/shared/CardSection/CardSection';
import Icon, { SvgSrc } from '~/components/shared/Icon/Icon';
import { Typography } from '~/components/shared/Typography/Typography';
import { formatAmount } from '~/helpers/formatters.helper';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store/types/sharedTypes';
import { ComponentSize } from '~/styles/BaseStyledComponents';
import { theme } from '~/styles/themes';
import FlexRow from './FlexRow';

const FlexSize = styled.div`
  flex: ${(props: { size?: number }) => props.size};
`;

const MaxAmount = styled.span`
  color: ${theme.colors.accent};
  margin-left: 0.2em;
  margin-right: 0.2em;
`;

interface Props {
  amountOriginal: number;
  maxAllowedAmount: number;
}

const Congrats: React.FC<Props> = ({ maxAllowedAmount, amountOriginal }) => {
  const translate = useTranslate();

  const { market } = useSelector((state: RootState) => state.intl);

  return (
    <CardSection>
      <Card>
        <FlexRow justify="flex-start">
          <FlexSize size={1}>
            <Icon
              src={SvgSrc.Rocket}
              size={ComponentSize.Medium}
              mr={1}
              pt={1}
            />
          </FlexSize>
          <FlexSize size={8}>
            <Typography fontWeight={800} lineHeight={2} element="h1">
              {translate('LoanConfigurationCard.Congratulations', {
                originalAmount: formatAmount(amountOriginal),
              })}
            </Typography>
            <Typography fontSize={0.9}>
              {translate('LoanConfigurationCard.CongratulationsText1')}
            </Typography>
            <Typography fontSize={0.9} color={theme.colors.accent}>
              <MaxAmount>{formatAmount(maxAllowedAmount)}</MaxAmount>
            </Typography>
            <Typography fontSize={0.9}>
              {market === CountryCode.FI &&
                translate('LoanConfigurationCard.CongratulationsText1-a')}
              .
            </Typography>
            <Typography lineHeight={1.5} fontSize={0.9}>
              {translate('LoanConfigurationCard.CongratulationsText2')}
            </Typography>
          </FlexSize>
        </FlexRow>
      </Card>
    </CardSection>
  );
};

export default Congrats;
